export default __webpack_public_path__ + "static/logov2-556e5a57777a58a38f28a7d55be5ddb2.png";